import { Alert, Button, Input, Modal } from "@minervaproject/fds";
import { useState } from "react";

import { DEFAULT_MODAL_STYLE } from "components/local_modal";
import { makeValidUrlOrFalse } from "utils/resource";

function AddUrlForm({
  handleAddUrl,
  handleClose,
}: {
  handleAddUrl: (validUrl: string) => void;
  handleClose: () => void;
}) {
  const [newUrl, setNewUrl] = useState("");
  const [addUrlError, setAddUrlError] = useState("");

  const handleSubmit = async () => {
    const validUrl = makeValidUrlOrFalse(newUrl);

    if (validUrl) {
      setAddUrlError("");

      const isHttpsUrl = validUrl.toLowerCase().indexOf("https://") !== -1;
      if (!isHttpsUrl) {
        setAddUrlError(
          "Insecure URLs do not work inside the classroom. Please make sure the URL starts with https://",
        );
        return;
      }

      handleAddUrl(validUrl);
    } else {
      setAddUrlError("The URL you have entered is not valid.");
    }
  };

  return (
    <Modal title="Add a Url" size="sm" onClose={handleClose} style={DEFAULT_MODAL_STYLE}>
      {!!addUrlError && (
        <Alert className="mb5" kind="error" showClose={false}>
          {addUrlError}
        </Alert>
      )}
      <form
        onSubmit={(e) => {
          e.preventDefault();
        }}
        data-testid="add-url-form"
      >
        <Input
          autoFocus
          fullWidth
          aria-label="new-url"
          onChange={(url: string) => setNewUrl(url)}
          value={newUrl}
        />
        <Button type="submit" disabled={!newUrl} mt={5} onClick={handleSubmit}>
          Submit
        </Button>
      </form>
    </Modal>
  );
}

export { AddUrlForm };
